<template>
  <html lang="pt-br">
    <head>      
      <meta name="description" content="Artigos e Publicações">

      <component-head-style/>
    </head>

    <body class="body-wrapper" data-spy="scroll" data-target=".privacy-nav">
      <component-nav-bar/>

        <section class="section about p-0">
          <div class="container" style="margin-top:80px">
            <div class="row">
              <div class="col-lg-6 align-self-center">
                <div class="content text-center text-lg-left">
                  <h2>Dívida Ativa - ISSQN - Simples Nacional</h2>

                  <p>
                    Levando em consideração o percentual de empresas optantes pelo Simples Nacional, a dívida ativa do ISSQN a ser importada para cobrança, 
                    cobrança esta, feita pelos municípios, possuem valores consideráveis, o que demonstraria reflexos importantes na arrecadação.
                    <br><br>
                    Grande parte dos municípios brasileiros não possuem convênio para promover a inscrição em dívida ativa e cobrança judicial do ISSQN não pago no Simples Nacional, 
                    no estado do Mato Grosso do Sul por exemplo apenas 26 dos 79 municípios possuem habilitação para tal procedimento.
                    <br><br>
                    Para que o município tenha acesso as informações e não deixe prescrever tais débitos a Procuradoria-Geral da Fazenda Nacional – PGFN, disponibiliza aos municípios a inscrição em dívida ativa e a cobrança judicial do ISSQN apurados no Simples Nacional, através de convênio.
                    O município deve formalizar e encaminhar o pedido até 31/10/2022 para ter acesso a partir de 2023 de todas as informações referentes aos débitos inscritos em Dívida Ativa do seu município. (Entre em contato caso o seu município não possua convênio, enviaremos o passo a passo para formalização do mesmo).
                    <br><br>
                    Para consultar se seu município possuí ou não convênio basta pesquisar em: 
                    <a href="http://www8.receita.fazenda.gov.br/SimplesNacional/Documentos/Pagina.aspx?id=5" target="_blank" style="color:blue">
                      Simples Nacional
                    </a>.
                  </p>
                </div>
              </div>

              <div class="col-lg-6 mt-4 mt-lg-0">
                <div class="about-slider">
                  <div class="item">
                    <img class="w-100" 
                          src="../../assets/images/ibcgp/publications/maxdividaativa.png" 
                          alt="Imagem de valores do instituto"
                          style="border-radius: 15px;">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      <section class="section cta-hire bg-gary">
        <contact/>
      </section>

      <component-footer/>

      <btn-to-top/>
    </body>

    <component-body-scripts/>
  </html>
</template>

<script>
  import Head from '../structure/Head.vue';
  import Navbar from '../structure/Navbar.vue';

  import Contact from '../contact/ShortcutContact.vue';

  import Footer from '../structure/Footer.vue';
  import BtnToTop from '../structure/BtnToTop.vue';
  import BodyScripts from '../structure/BodyScripts.vue';

  export default {
    created(){
      document.title = "IBCGP | Artigos e Publicações";
    },
    components:{
      'component-head-style'    : Head,
      'component-nav-bar'       : Navbar,

      'contact'                 : Contact,

      'component-footer'        : Footer,
      'btn-to-top'              : BtnToTop,
      'component-body-scripts'  : BodyScripts
    },
    beforeMount() {
      this.navPublications = true;
    }
  }
</script>